// @ts-nocheck
import { FCM_TOKEN_REQUEST_COMPLETE, FCM_TOKEN_REQUEST_LOADING, RESET_FIREBASE_SLICE } from "../constants/firebaseReduxConstants";


const initialState = {
  fcmToken: {
    isLoading: false
  }
};

const firebaseReducer = (state = initialState, action) => {
  switch (action?.type) {

    case FCM_TOKEN_REQUEST_LOADING: {
      return {
        ...state,
        fcmToken: {
          ...state.fcmToken,
          isLoading: true
        }
      }
    }

    case FCM_TOKEN_REQUEST_COMPLETE: {
      return {
        ...state,
        fcmToken: {
          ...state.fcmToken,
          isLoading: false
        }
      }
    }

    case RESET_FIREBASE_SLICE: {
      return {
        ...initialState
      }
    }

    default:
      return state;
  }
};

export default firebaseReducer;
export {
  initialState
}